import * as React from "react";

/** Shared chrome so every visualization in the gallery reads as one system. */
export default function VizFrame({
  title,
  meta,
  children,
}: React.PropsWithChildren<{ title: string; meta: string }>) {
  return (
    <div className="panel overflow-hidden">
      <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 border-b px-4 py-3">
        <h4 className="text-sm font-medium">{title}</h4>
        <p className="font-mono text-2xs text-faint">{meta}</p>
      </div>
      {children}
    </div>
  );
}
